import { createStructuredSelector } from "reselect";
import { createSelector } from "@reduxjs/toolkit";
import { Selectors as ProfileSelectors } from "@/store/clientProfile/selectors";
import { Selectors as PortfolioSelectors } from "@/store/portfolio/selectors";
import { Selectors as FavSelectors } from "@/store/favorites/selectors";
import last from "lodash/last";

const getRawItems = (state) => state.clientFeed.items;

const getConnectedItems = createSelector(
  [getRawItems, ProfileSelectors.getExcerpt, PortfolioSelectors.getPortfolio],
  (items, client, portfolio) => {
    return items.map((item) => {
      let actualEntity;
      if (item.entity_ref === "Portfolio") {
        const found = portfolio.find(({ _id }) => _id === item.entity._id);
        actualEntity = found || item.entity;
      } else {
        actualEntity = item.entity;
      }
      return {
        ...item,
        entity: {
          ...actualEntity,
          client,
        },
      };
    });
  }
);
const isMore = (state) => state.clientFeed.isMore;
const getLastActivity = createSelector(getRawItems, (items) => {
  return last(items);
});
const isLoading = (state) => state.clientFeed.loading;
const getError = (state) => state.clientFeed.error;
const getFavorites = createStructuredSelector({
  Review: FavSelectors.getFavoriteReviews,
  Portfolio: FavSelectors.getFavoritePortfolio,
});

export const Selectors = {
  isMore,
  getLastActivity,
  getFavorites,
  getItems: getConnectedItems,
  isLoading,
  getError,
};
